module.exports = __webpack_public_path__ + "static/media/logo-reduniq.2981c6a2.svg";